import { captureGenericError } from 'src/lib/sentry';

/**
 * Get path to accessory item asset
 */
export function getAccessoryPath(
  image: string | undefined,
  id: string,
): string {
  if (!image) {
    captureGenericError(`Accessory ${id} is missing an image asset`, null);
    return ``;
  }

  return `assets/accessories/${image}`;
}
